/**
 * 图标状态枚举
 * @en Icon status enum
 *  */
export var IconStatus;

(function (IconStatus) {
  IconStatus["NORMAL"] = "normal";
  IconStatus["DISABLED"] = "disabled";
  IconStatus["ACTIVE"] = "active";
  IconStatus["ACTIVE_DISABLED"] = "activeDisabled";
})(IconStatus || (IconStatus = {}));